export default (to, from, savedPosition) =>
	savedPosition || {
		x: 0,
		y: 0,
	};
